import React from "react";
import MobileFooter from "./MobileFooter";
import FooterDesktop from "./FooterDesktop";
import "./footer.scss";
import { useAppSelector } from "../../../store/index.ts";

export default function Footer() {
  const isLsm = useAppSelector((state) => state.deviceSize.isLsm);

  return isLsm ? <MobileFooter /> : <FooterDesktop />;
}
